import {
  CAMPAIGN_OWNER,
  REPORT_TYPE,
  DATE_RANGE,
  SET_LOADING,
  GET_REPORTS,
  FILTERED_REPORTS,
  GET_REPORTS_ERROR,
} from "../types";

const ReportReducer = (state, action) => {
  switch (action.type) {
    case CAMPAIGN_OWNER:
      return { ...state, owner: action.payload };

    case REPORT_TYPE:
      if (action.payload.owner === "Alvin") {
        return { ...state, report_type_alvin: action.payload.type };
      } else if (action.payload.owner === "Aureas") {
        return { ...state, report_type_aureas: action.payload.type };
      }

    case DATE_RANGE:
      return { ...state, date_range: action.payload };

    case SET_LOADING:
      return { ...state, reports_loading: true };

    case GET_REPORTS:
      return {
        ...state,
        reports_loading: false,
        reports: action.payload,
        // reports: action.payload[0],
        // media_buyer_reports: action.payload[1],
      };

    case FILTERED_REPORTS:
      return { ...state, filtered_reports: action.payload };

    case GET_REPORTS_ERROR:
      return { ...state, reports_error: action.payload };

    default:
      return state;
  }
};


export default ReportReducer;